import slick from 'slick-carousel';
import $ from 'jquery';

const initCarousel = (classname, options) => {
  $(`.${classname}`).slick(options);
};

export { initCarousel };
